import config from 'config/config';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BusinessChoiceSelector } from 'store/selectors';

export default function useBillConfig() {
  const businessChoice = useSelector(BusinessChoiceSelector);
  const currentConfig = useMemo(() => {
    let returnValue = config.options.bill.defaultValues;
    const overrideValues = config.options.bill[businessChoice];

    if (overrideValues) {
      returnValue = { ...returnValue, ...overrideValues };
    }
    return returnValue;
  }, [businessChoice]);

  return currentConfig;
}
